// ============================================
// Tiện ích cho các lời gọi fetch() thô (màn auth chưa dùng api-client).
//
// Bug #7: `await response.json()` ném "JSON Parse Error: ... is not valid JSON"
// mỗi khi server trả về thứ không phải JSON — 404/500 của Django là trang HTML,
// proxy/gateway trả text, hoặc body rỗng. Lỗi kỹ thuật đó lọt thẳng lên UI thay
// cho thông báo mà người dùng có thể hiểu.
//
// Mọi màn gọi fetch() trực tiếp PHẢI parse qua đây.
// ============================================

export interface ApiErrorBody {
  message?: string;
  error?: { message?: string };
  errors?: Record<string, string | string[]>;
  [key: string]: unknown;
}

/**
 * Đọc body response dưới dạng JSON; không parse được thì trả `null`.
 * Không bao giờ ném lỗi.
 */
export async function readJsonSafely(response: Response): Promise<ApiErrorBody | null> {
  let raw = '';
  try {
    raw = await response.text();
  } catch {
    return null;
  }

  if (!raw.trim()) return null;

  try {
    return JSON.parse(raw) as ApiErrorBody;
  } catch {
    return null;
  }
}

/**
 * Gom thông điệp lỗi dễ đọc từ body API.
 * Thứ tự ưu tiên: `message` ở root -> `error.message` (BE cũ) -> gộp `errors`
 * theo từng field -> `fallback`.
 */
export function resolveApiErrorMessage(body: ApiErrorBody | null, fallback: string): string {
  if (!body) return fallback;

  if (typeof body.message === 'string' && body.message.trim()) return body.message;
  if (typeof body.error?.message === 'string' && body.error.message.trim()) return body.error.message;

  if (body.errors && typeof body.errors === 'object') {
    const parts = Object.entries(body.errors)
      .map(([field, value]) => `${field}: ${Array.isArray(value) ? value.join(', ') : value}`)
      .filter(Boolean);
    if (parts.length > 0) return parts.join('; ');
  }

  return fallback;
}
